export default __webpack_public_path__ + "static/media/natasha.ed100122.png";